// import Cookies from 'js-cookie'

import { formatDate } from './date';
const OpenidKey = 'openid_key_' + formatDate(new Date(), 'yyyy_MM_dd');
enum AUTH_KEY {
  TokenKey = 'token_key',
  ExpiresInKey = 'Admin-Expires-In',
}
export function getToken(): string {
  return (localStorage.getItem(AUTH_KEY.TokenKey) as string) || '';
}

export function setToken(token: string): void {
  localStorage.setItem(AUTH_KEY.TokenKey, token);
}

export function removeToken(): void {
  localStorage.removeItem(AUTH_KEY.TokenKey);
}

export function getOpenId() {
  return (localStorage.getItem(OpenidKey) as string) || '';
}

export function setOpenId(OpenId: string): void {
  localStorage.setItem(OpenidKey, OpenId);
}

export function removeOpenId(): void {
  localStorage.removeItem(OpenidKey);
}

// export function getPower() {
//   return localStorage.getItem(AUTH_KEY.PowerKey) as string || '0'
// }

// export function setPower(val:string) :void{
//   localStorage.setItem(AUTH_KEY.PowerKey, val)
// }

// export function removePower():void {
//   localStorage.removeItem(AUTH_KEY.PowerKey)
// }
